import React, { useState, useEffect, useContext } from "react";
import CustomFilters from "../../../core/custom-filters";
import { Box, TextField } from "@mui/material";
import { HTTP_METHODS, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import SiAutocomplete from "../../../core/si-autocomplete";
import SiTextField from "../../../core/si-textfield";
import AppContext from "../../../utils/context";
import { USER_ROLES } from "../../../utils/constants";
import { PAGE_LIMIT } from "../../../utils";

const ExportEngineFilters = ({ loadData, isSap = false }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [oemList, setOemList] = useState([]);
  const [endDate, setEndDate] = useState("");
  const { userDetails = {} } = useContext(AppContext);

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          if (key === "dateOfClaimSubmission") {
            payload["startDate"] = filters[key];
            if (endDate) {
              payload["endDate"] = endDate;
            }
          } else {
            payload[key] = filters[key];
          }
        }
      }

      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
      });
    } else {
      loadData({ sortBy: "-createdAt", limit: PAGE_LIMIT, page: 1 });
    }
  };

  const filterTypes = () => {
    const filtersArr = [
      { label: "Engine Number", value: "engineNo" },
      { label: "Engine Model", value: "engineModel" },
      { label: "List Number", value: "listNumber" },
      { label: "Machine Model", value: "machineModel" },
      { label: "Plant", value: "plant" },
      { label: "Location", value: "location" },
      { label: "Country", value: "country" },
      { label: "OEM", value: "oemOrg" },
    ];
    return filtersArr;
  };

  const renderFilterInput = () => {
    switch (filterType) {
      case "engineNo":
        return (
          <SiTextField
            placeholder="Engine Number"
            name="engineNo"
            onChange={handleFilterValueChange}
          />
        );
      case "engineModel":
        return (
          <SiTextField
            placeholder="Engine Model"
            name="engineModel"
            onChange={handleFilterValueChange}
          />
        );
      case "listNumber":
        return (
          <SiTextField
            placeholder="List Number"
            name="listNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "machineModel":
        return (
          <SiTextField
            placeholder="Machine Model"
            name="machineModel"
            onChange={handleFilterValueChange}
          />
        );
      case "plant":
        return (
          <SiTextField
            placeholder="Plant"
            name="plant"
            onChange={handleFilterValueChange}
          />
        );
      case "location":
        return (
          <SiTextField
            placeholder="Location"
            name="location"
            onChange={handleFilterValueChange}
          />
        );
      case "country":
        return (
          <SiTextField
            placeholder="Country"
            name="country"
            onChange={handleFilterValueChange}
          />
        );
      case "oemOrg":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oemList}
            placeholder="Search OEM"
          />
        );
      default:
        return null;
    }
  };

  const getOemList = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null)
      .then((response) => {
        if (Array.isArray(response) && response) {
          let oems = response.map((r) => ({
            label: r.name,
            value: r.id,
          }));
          setOemList(oems);
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getOemList();
  }, []);

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes()}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default ExportEngineFilters;
